import { Route, Routes } from 'react-router-dom';
import { PrivateRoute } from '../components/PrivateRoute';
import { UserBookCreate } from './create/UserBookCreate';
import { UserBookCoverForm } from './book/UserBookCoverForm';
import { UserBookList } from './book/UserBookList';
import { UserBookView } from './book/UserBookView';
import { UserBookEpisodeView } from './episode/UserBookEpisodeView';
import { UserBookReady } from './book/UserBookReady';
import { UserBookModify } from './book/UserBookModify';
import { UserBookPopular } from './UserBookPopular';
import { UserBookHeader } from './common/UserBookHeader';
import { UserBookEpisodeEdit } from './episode/UserBookEpisodeEdit';
import { UserBookEpisodeCreate } from './episode/UserBookEpisodeCreate';

export const UserBookPage = ()=>{
    return (
        <div className="userBookPage subpage" id="userbook_subpage">
            <UserBookPopular />
            <UserBookHeader />
            <Routes>
                <Route path="/" element={ <UserBookList/> } /> 
                <Route path="/create" element={ <PrivateRoute><UserBookCreate/></PrivateRoute> } /> 
                <Route path="/ready/:book" element={ <PrivateRoute><UserBookReady/></PrivateRoute> } /> 

                <Route path="/edit/:book" element={ <PrivateRoute><UserBookModify/></PrivateRoute> } /> 
                <Route path="/cover/:book" element={ <PrivateRoute><UserBookCoverForm/></PrivateRoute> } /> 
                <Route path="/view/:book" element={ <PrivateRoute><UserBookView/></PrivateRoute> } />
                <Route path="/episode/create/:book" element={ <PrivateRoute><UserBookEpisodeCreate /></PrivateRoute> } /> 
                <Route path="/episode/edit/:book/:episode" element={ <PrivateRoute><UserBookEpisodeEdit /></PrivateRoute> } /> 

                {/* 여기만 도서정보가 없네? */}
                <Route path="/episode/view/:episode" element={ <PrivateRoute><UserBookEpisodeView /></PrivateRoute> } /> 
            </Routes>

        </div>
    );
    
};